<template lang="pug">
  .rappers__preloader
    img(src="@/assets/img/global/loader.gif" alt="")
</template>

<script>
export default {
  name: 'RappersPreloader'
}
</script>
